module.exports = __webpack_public_path__ + "static/media/Source Info.502068b9.txt";